import { Grid } from '@mui/material'
import { Container, Form } from 'react-bootstrap'
import { Autocomplete } from '@react-google-maps/api'
import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../app/stores/store'
import { PostMode } from '../../app/models/modes'
import Instructions from './stepper/Instructions'
import { BuyerSteps } from '../../app/data/stepper'
import { AuctionCardLine } from './Lines/AuctionCardLine'

enum TabTypes {
  Instructions,
  Search,
}
function HomeFilter() {
  const { homeFilterStore } = useStore()
  const { setShow, listHomeFilter, search, setSearch } = homeFilterStore
  const [value, setValue] = useState<any>()
  const [tabActive, setTabActive] = useState<TabTypes>(TabTypes.Instructions)
  const { t } = useTranslation()

  const handleBlurEvent = (event: any) => {
    const address = event.target.value.split(',').slice(0, 1)
    event.target.value = address
  }

  const onLoadPlaces = (e: any) => {
    setValue(e)
  }

  const onPlacesChanged = () => {
    const google = value.getPlace()
    const components = google.address_components
    const cityComponent = components.find((c: any) => c.types.includes('locality'))

    setSearch({ ...search, city: cityComponent.long_name })
  }

  const handleInputChange = (e: any) => {
    const { name, value } = e.target
    setSearch({ ...search, [name]: value })
  }

  const handleInputChangeNumber = (e: any) => {
    const { name, value } = e.target
    const parsedValue = parseInt(value)
    setSearch({
      ...search,
      [name]: isNaN(parsedValue) ? 0 : parsedValue,
    })
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    listHomeFilter(search)

    setShow(true)
  }

  const searchSection = () => {
    return (
      <>
        <Form onSubmit={handleSubmit} className='main-input-size center-main'>
          <Grid
            style={{ gap: '20px' }}
            container
            className='align-end center-main main-input-search'
          >
            {inputValues.map((input, index) => (
              <Grid item key={index}>
                <Form.Label>{input.label}</Form.Label>
                <Form.Select
                  name={input.name}
                  onChange={input.onChange}
                  className={input.className}
                >
                  {input.options?.map((option, optionIndex) => (
                    <option key={optionIndex} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Grid>
            ))}
            <Grid item>
              <Form.Label>
                {t('location')}, {t('city')}
              </Form.Label>
              <div className='d-flex input-container'>
                <Autocomplete
                  restrictions={{ country: ['CH', 'PL'] }}
                  types={['(cities)']}
                  className='autocomplete-input'
                  onLoad={onLoadPlaces}
                  onPlaceChanged={onPlacesChanged}
                >
                  <Form.Control
                    className='main-nav-input-width'
                    type='text'
                    name='city'
                    onBlur={handleBlurEvent}
                    onChange={handleInputChange}
                    value={search.city}
                    placeholder={t('enter_location') as string}
                  />
                </Autocomplete>
              </div>
            </Grid>
            <Grid item className='button-hidden-1'>
              <button type='submit' className='text-white search-button'>
                {t('search')}
              </button>
            </Grid>
          </Grid>
          <div className='pt-3'>
            <AuctionCardLine />
          </div>
          <Grid
            container
            style={{ gap: '20px' }}
            className='align-end second-card-size d-flex justify-content-center  center-main main-input-search'
          >
            <Grid item>
              <Form.Label>{t('price_from')}</Form.Label>
              <div className='input-value input-value-CHR '>
                <Form.Control
                  placeholder='1000'
                  name='priceFrom'
                  onChange={handleInputChangeNumber}
                  type='number'
                  className='text-end'
                  min={0}
                />
              </div>
            </Grid>
            <div className='main-blocked'>
              <span className='d-flex  align-items-center minus' />
            </div>
            <Grid item>
              <Form.Label>{t('price_to')}</Form.Label>
              <div className='input-value input-value-CHR '>
                <Form.Control
                  placeholder='1000000'
                  name='priceTo'
                  className='text-end'
                  onChange={handleInputChangeNumber}
                  type='number'
                  min={0}
                />
              </div>
            </Grid>
            <div className='main-blocked main-vr-padding'>
              <div className='d-flex text-black' style={{ height: '88px' }}>
                <div className='vr' />
              </div>
            </div>
            <Grid item>
              <Form.Label>{t('meters_from')}</Form.Label>
              <div className='input-value input-value-meters'>
                <Form.Control
                  placeholder='10'
                  name='metersFrom'
                  className='text-end'
                  onChange={handleInputChangeNumber}
                  type='number'
                  min={0}
                  max={1000000}
                />
              </div>
            </Grid>
            <div className='main-blocked'>
              <span className='d-flex  align-items-center minus' />
            </div>
            <Grid item>
              <Form.Label>{t('meters_to')}</Form.Label>
              <div className='input-value input-value-meters'>
                <Form.Control
                  placeholder='100'
                  name='metersTo'
                  className='text-end'
                  inputMode='numeric'
                  pattern='[0-9]+([,][0-9]{1,2})?'
                  onChange={handleInputChangeNumber}
                  type='number'
                  min={0}
                  max={1000000}
                />
              </div>
            </Grid>
            <Grid item className='button-hidden-2'>
              <button type='submit' className='text-white search-button'>
                Search
              </button>
            </Grid>
          </Grid>
        </Form>
      </>
    )
  }
  const renderSection = () => {
    if (tabActive === TabTypes.Instructions) {
      return (
        <>
          <div className='d-flex items-center'>
            <Instructions key={'Buyer'} steps={BuyerSteps} />
          </div>
        </>
      )
    } else {
      return searchSection()
    }
  }

  const inputValues = [
    {
      label: t('acquisition_options'),
      name: 'propertyType',
      onChange: handleInputChangeNumber,
      className: 'main-nav-select-width',
      options: [
        { label: t('all'), value: PostMode.All },
        { label: t('buy_now'), value: PostMode.BuyNow },
        { label: t('first_wins'), value: PostMode.FirstWins },
        { label: t('auction'), value: PostMode.Auction },
      ],
    },
    {
      label: t('residential_spaces'),
      name: 'propertyForm',
      onChange: handleInputChange,
      className: 'main-nav-select-width',
      options: [
        { label: t('all'), value: 'all' },
        { label: t('house'), value: 'house' },
        { label: t('office'), value: 'office' },
        { label: t('appartment'), value: 'appartment' },
        { label: t('villa'), value: 'villa' },
      ],
    },
  ]

  return (
    <Container className='home-navigation-size newFont prevent-select card-shadow background-color position-relative'>
      <div className='home-nav-title'>
        <p>{t('home_img_header')}</p>
        <p>{t('home_img_desc')}</p>
      </div>

      <div className='d-flex button-container'>
        <button
          onClick={() => setTabActive(TabTypes.Instructions)}
          className={`main-search-button border-left border-right ${tabActive === TabTypes.Instructions ? 'tab-active' : 'tab-inactive'}`}
        >
          {t('steper_main.tab_name')}
        </button>
        <button
          onClick={() => setTabActive(TabTypes.Search)}
          className={`main-search-button border-left border-right ${tabActive === TabTypes.Search ? 'tab-active' : 'tab-inactive'}`}
        >
          {t('seek')}
        </button>
        {/* <button className="main-search-button2">Result</button> */}
      </div>
      {renderSection()}
    </Container>
  )
}

export default observer(HomeFilter)
